import {
    QUESTIONNAIRES_REQUEST_FAIL,
    QUESTIONNAIRES_REQUEST_SUCCESS
  } from '../action.types';
  import initialState from '../initial.state';
  
  export default function(state = initialState.questionnaires, action) {
    switch (action.type) {
      case QUESTIONNAIRES_REQUEST_SUCCESS:
        return { ...action.payload };
      case QUESTIONNAIRES_REQUEST_FAIL:
        return state;
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/redux/quiz/questionnaires.reducer.js